import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
const userID = cookies.get("USER_ID");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getBuyersService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/buyers`);
  return res;
};

export const getBuyerService = async (buyerID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/buyers/${buyerID}`);
  return res;
};

export const getSaleService = async (office: string, saleID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/sales/${saleID}?office=${office}`);
  return res;
};

export const getMaterialService = async (materialID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/sales/materials/${materialID}`);
  return res;
};

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

export const getCategoriesService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/categories`);
  return res;
};

export const postBuyerSelectedService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.post(`${apiURL}/metalstrading/api/buyers/selected`, payload);
  return res;
};

export const postAddToSaleService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.post(`${apiURL}/metalstrading/api/sales/materials`, payload);
  return res;
};

export const postBuyerService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.post(`${apiURL}/metalstrading/api/buyers`, payload);
  return res;
};

export const postMetalService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.post(`${apiURL}/metalstrading/api/metals`, payload);
  return res;
};

export const putCompleteSaleService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.updatedByUserID = userID;
  const res = await axios.put(`${apiURL}/metalstrading/api/sales/completed`, payload);
  return res;
};

export const putMaterialService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.updatedByUserID = userID;
  const res = await axios.put(`${apiURL}/metalstrading/api/sales/materials/${payload.materialID}`, payload);
  return res;
};

export const putSaleDateService = async (saleID: string, payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.updatedByUserID = userID;
  const res = await axios.put(`${apiURL}/metalstrading/api/sales/saleDate/${saleID}`, payload);
  return res;
};

export const deleteMaterialService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.updatedByUserID = userID;
  const res = await axios.delete(
    `${apiURL}/metalstrading/api/sales/materials/${payload.materialID}/sale/${payload.saleID}/office/${payload.office}`
  );
  return res;
};
